import React, { useEffect } from "react";
import css from "./Printing.module.scss";
import SecOne from "./SecOne/SecOne";
import SecTwo from "./SecTwo/SecTwo";
import SecThree from "./SecThree/SecThree";
import SecFour from "./SecFour/SecFour";
import SecFive from "./SecFive/SecFive";
import { constants } from "assets/constants";
import { Helmet } from "react-helmet";

const Printing = () => {
    return (
        <div className={css.printing}>
            <Helmet>
                <title>{constants.titles.services_printing}</title>
                <meta name="description" content={constants.descriptions.services_printing} />
            </Helmet>
            <SecOne />
            <SecTwo />
            <SecThree />
            <SecFour />
            <SecFive />
        </div>
    );
};

export default Printing;
